package com.eladfinish.bible.contest.screens.openQuestions.usecases

import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.common.gender.getHebrewGender
import com.eladfinish.bible.contest.common.gender.personalizeGender
import com.eladfinish.bible.contest.data.common.stringResolver.StringResolver
import com.eladfinish.bible.contest.network.spreadsheet.GoogleSheetRowHeadersAndValues
import com.eladfinish.bible.contest.network.spreadsheet.SpreadsheetApi
import com.eladfinish.bible.contest.network.spreadsheet.handleApiResult
import com.eladfinish.bible.contest.network.spreadsheet.toSpreadsheetMatrixWithHeaders
import com.eladfinish.bible.contest.open_questions_instruction
import com.eladfinish.bible.contest.screens.openQuestions.DOUBLE_EXCLAMATION_MARKS
import com.eladfinish.bible.contest.screens.openQuestions.model.QuestionItem
import com.eladfinish.bible.contest.screens.openQuestions.model.QuestionItemJson
import com.eladfinish.bible.contest.screens.openQuestions.model.untilStopMark
import com.eladfinish.bible.contest.screens.openQuestions.noPrecedingSymbols
import com.eladfinish.bible.contest.str_questions
import com.eladfinish.bible.contest.topic
import com.russhwolf.settings.Settings
import dev.icerock.moko.resources.desc.desc
import kotlinx.coroutines.flow.first
import kotlinx.coroutines.flow.map

class GetQuestionsAndAnswersUseCase(
    private val spreadsheetApi: SpreadsheetApi,
    private val stringResolver: StringResolver,
    private val settings: Settings,
) {

    suspend operator fun invoke(
        spreadsheetId: String,
        sheetId: String,
        topicName: String,
        onItems: (List<QuestionItem>) -> Unit,
        onTitle: (String) -> Unit,
    ): Result<Unit> =
        spreadsheetApi.getDataFromSpreadsheet(spreadsheetId = spreadsheetId, sheetId = sheetId)
            .handleApiResult { result ->
                val shouldRevealAnswers = topicName.startsWith(DOUBLE_EXCLAMATION_MARKS)

                result.data.toSpreadsheetMatrixWithHeaders()
                    .map { rows: List<GoogleSheetRowHeadersAndValues> ->
                        rows.map { row ->
                            QuestionItemJson(list = row.listNoIndexes, index = row.index)
                        }
                    }
                    .map { jsons ->
                        val limited = jsons.untilStopMark { it.question }

                        val items = limited.mapIndexed { index, json ->
                            QuestionItem(
                                question = json.question.orEmpty(),
                                answer = json.answer.orEmpty(),
                                author = json.author.orEmpty(),
                                book = json.book.orEmpty(),
                                chapter = json.chapter.orEmpty(),
                                verse = json.verse.orEmpty(),
                                regex = json.regex.orEmpty(),
                                isAnswerVisible = shouldRevealAnswers,
                                num = index + 1,
                            )
                        }
                        onItems(items)

                        val topic = stringResolver.resolveString(SharedRes.strings.topic.desc())
                        val questions = stringResolver.resolveString(SharedRes.strings.str_questions.desc())
                        val instruction = stringResolver.resolveString(SharedRes.strings.open_questions_instruction.desc())
                            .personalizeGender(settings.getHebrewGender())
                        onTitle("$topic: *${topicName.noPrecedingSymbols()}* (${items.size} $questions)\n $instruction")

                        Result.success(Unit)
                    }
                    .first()
            }
}
